import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles'
import { TableCell, TableRow } from '@material-ui/core'

import { useTableStyles } from '../hooks/tableStylesHook'

import { formatPrice } from '../common/numberUtils'

import { MoySkladProductPriceModel } from '../server/mpsklad_core/Models/MoySkladProductPriceModel'

export type MoySkladProductPriceRowProps = {
  price: MoySkladProductPriceModel
}

export const MoySkladProductPriceRow =
  observer(
    ({price}: MoySkladProductPriceRowProps) => {
      const classes = useStyles()
      const tableClasses = useTableStyles()

      return (
        <TableRow>
          <TableCell className="table-border">
            <span className={classes.text}>{price.name}</span>
          </TableCell>

          <TableCell className={clsx('table-border', tableClasses.noWrapCell)}>
            <span className={classes.text}>{formatPrice(price.value)}</span>
          </TableCell>
        </TableRow>
      )
    })

const useStyles = makeStyles(() => ({
  text: {
    fontSize: 12
  },
  iconButton: {
    marginLeft: 5,
    opacity: 0,
    'td:hover &': {
      opacity: 1
    }
  }
}))